const data = {
  pageName: "FixedContract",
  services: {
    sendOtp: {
      url: "FixedContract/sendOtp",
      params: {}
    },
    validateOtp: {
      url: "FixedContract/validateOtp",
      params: {}
    },
    translations: {
      url: "FixedContract/translations",
      params: {}
    }
  }
};

exports.data = data;
